export const getCityWithPreposition = (city: string = ""): string => {
 // Vérifie si le nom de la ville contient une prépoition ou commence par une voyelle ou un "h" muet
  const preposition = /^de |^d'/.test( city )
  ? ""
  : /^[aeiouhAEIOU]/.test(city) ? "d'" : "de ";
  return /^de $|^d'$/.test( city ) ? "" : `${preposition}${city}`
};